exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-list{min-height:25em;margin-bottom:0\n}\n.emtpy-chat-list-alert{padding:3em;font-size:1.2em;display:flex;justify-content:center;color:#b9b9ba;color:var(--faint, #b9b9ba)\n}", ""]);

// exports
